import axios from "axios";
import {SERVER_IP} from "./constants";
import {SERVER_IP_MULTIDOC} from "./constants";
import {generalAdminNotification} from "./api";

export const initializeMultidoc = async (multidoc_title, user_id, serverIP) => {
    console.log("body for initialize_multidoc", {
        "multidoc_title": multidoc_title.toString(),
        "user_id": user_id.toString(),
    });

    try {
        const response = await axios.post(serverIP + '/multidoc/initialize_multidoc', {
            "multidoc_title": multidoc_title.toString(),
            "user_id": user_id.toString(),
        });
        console.log("initialize_multidoc_clicked", response)

        if (response.data.status === 429) {
            alert("We're experiencing unusually high traffic right now. Please try again in a few minutes!")
        }
        else if (response.data.status === 200) {
            return {
                "status" : 200,
                "id": response.data.message.multidocID,
                // "id": response.data.message.generationID,
                // "name": response.data.message.generationTitle,
                // "messages": response.data.message.generations,
                // "files": response.data.message.sources,
            }
        }
    } catch (error) {
        console.log("/initialize_multidoc error", error);
        return null;
    }
}

export const createMultidocSession = async (multidoc_id, user_id, serverIP) => {
    try {
        const response = await axios.post(serverIP + '/multidoc/create_multidoc_session', {
            "multidoc_id": multidoc_id.toString(),
            "user_id": user_id.toString(),
        });
        console.log("create_multidoc_session_clicked", response)

        if (response.data.status === 429) {
            alert("We're experiencing unusually high traffic right now. Please try again in a few minutes!")
        }
        else if (response.data.status === 401 && response.data.message.message === "One or more of the sources uploaded to this multidoc has no discernable text in it, please remove these sources and try again.") {
            return {
                "status" : 401,
                "multidocSessionToken": null,
                "source_ids_with_no_discernable_text": response.data.message.source_ids_with_no_discernable_text,
            }
        }
        else if (response.data.status === 200) {
            return {
                "status" : 200,
                "multidocSessionToken": response.data.message.multidoc_session_token,
                // "id": response.data.message.mulID,
                // "name": response.data.message.multidocTitle,
                // "messages": response.data.message.chats,
                // "files": response.data.message.sources,
            }
        }
    } catch (error) {
        console.log("/create_multidoc_session error", error);
        return null;
    }
}

export const createMultidocSessionNativeChat = async (multidoc_id, user_id, serverIP) => {
    try {
        const response = await axios.post(serverIP + '/multidoc/create_session_multidoc_native_chat', {
            "multidoc_id": multidoc_id.toString(),
            "user_id": user_id.toString(),
        });
        console.log("create_multidoc_session_image_clicked", response)

        if (response.data.status === 429) {
            alert("We're experiencing unusually high traffic right now. Please try again in a few minutes!")
        }
        else if (response.data.status === 401 && response.data.message.message === "One or more of the sources uploaded to this multidoc has no discernable text in it, please remove these sources and try again.") {
            return {
                "status" : 401,
                "multidocSessionToken": null,
                "source_ids_with_no_discernable_text": response.data.message.source_ids_with_no_discernable_text,
            }
        }
        else if (response.data.status === 200) {
            return {
                "status" : 200,
                "multidocSessionToken": response.data.message.multidoc_session_token,
                "progressKey": response.data.message.progress_key,
                // "id": response.data.message.mulID,
                // "name": response.data.message.multidocTitle,
                // "messages": response.data.message.chats,
                // "files": response.data.message.sources,
            }
        }
    } catch (error) {
        console.log("/create_multidoc_session_image error", error);
        return null;
    }
}

export const getMultidoc = async (multidoc_id, user_id, serverIP) => {
    console.log("/get_multidoc REQUEST BODY", {
        "multidoc_id": multidoc_id.toString(),
        "user_id": user_id.toString(),
    });
    // response.data.session_token or response.data.url
    try {
        const response = await axios.post(serverIP + '/multidoc/get_multidoc', {
            "multidoc_id": multidoc_id.toString(),
            "user_id": user_id.toString(),
        });
        console.log("response for get_multidoc", response)

        if (response.data.status === 429) {
            alert("We're experiencing unusually high traffic right now. Please try again in a few minutes!")
        }
        else if (response.data.status === 200) {
            return {
                "status" : 200,
                "id": response.data.message.multidocID,
                "name": response.data.message.multidocTitle,
                "messages": response.data.message.chats,
                "files": response.data.message.sources,
                "originalFiles": response.data.message.originalSources,
            }
        }
    } catch (error) {
        console.log("/get_multidoc error", error);
        return null;
    }
}

export const getMultidocNative = async (multidoc_id, user_id, serverIP) => {
    console.log("/get_multidoc native REQUEST BODY", {
        "multidoc_id": multidoc_id.toString(),
        "user_id": user_id.toString(),
    });
    // response.data.session_token or response.data.url
    try {
        const response = await axios.post(serverIP + '/multidoc/get_multidoc', {
            "multidoc_id": multidoc_id.toString(),
            "user_id": user_id.toString(),
        });
        console.log("response for get_multidoc native", response)

        if (response.data.status === 429) {
            alert("We're experiencing unusually high traffic right now. Please try again in a few minutes!")
        }
        else if (response.data.status === 200) {
            return {
                "status" : 200,
                "id": response.data.message.multidocID,
                "name": response.data.message.multidocTitle,
                "messages": response.data.message.chats,
                "files": response.data.message.originalSources,
            }
        }
    } catch (error) {
        console.log("/get_multidoc native error", error);
        return null;
    }
}

export const fetchMultidocs = async (userID, serverIP) => {
    console.log("fetch multidocs userID", userID)
    try {
        const response = await axios.post(serverIP + '/multidoc/list_multidocs', {
            "user_id" : userID,
        });
        console.log("response for fetch multidocs", response)
        if (response.data.status === 200) {
            const documentListGeneration = [];
            for (let i = 0; i < response.data.message.length; i++) {
                documentListGeneration.push({
                    "id" : response.data.message[i].multidoc_id,
                    "name" : response.data.message[i].multidoc_title,
                    "lastOpenTime" : response.data.message[i].last_open_time,
                    "messages" : [],
                    "files" : [],
                });
            }
            return {
                "status" : 200,
                "multidocs" : documentListGeneration,
            }
        }
    } catch (error) {
        console.log("/list_multidocs error", error);
        return null;
    }
}

export const fetchMultidocsNative = async (userID, serverIP) => {
    console.log("fetch multidocs native userID", userID)
    console.log("SERVER IP FOR LIST MULTIDOCS NATIVE", serverIP)
    try {
        const response = await axios.post(serverIP + '/multidoc/list_multidocs_native', {
            "user_id" : userID,
        });
        console.log("response for fetch multidocs native", response)
        if (response.data.status === 200) {
            const documentListGeneration = [];
            for (let i = 0; i < response.data.message.length; i++) {
                documentListGeneration.push({
                    "id" : response.data.message[i].multidoc_id,
                    "name" : response.data.message[i].multidoc_title,
                    "lastOpenTime" : response.data.message[i].last_open_time,
                    "messages" : [],
                    "files" : [],
                    "urls": response.data.message[i].original_sources_presigned_urls,
                });
            }
            return {
                "status" : 200,
                "multidocs" : documentListGeneration,
            }
        }
    } catch (error) {
        console.log("/list_multidocs_native error", error);
        return null;
    }
}

export const multidocChat = async (user_id, generation_session_token, prompt,
                                   socketID, toast, messageHistory, serverIP, citationFormat = "default", websearch = false) => {
    console.log("multidoc chat request body", {
        "user_id": user_id.toString(),
        "multidoc_session_token": generation_session_token.toString(),
        "prompt": prompt.toString(),
        // "word_count": word_count,
        // "should_reference_sources": should_reference_sources,
        "socketio_sid": socketID,
        "message_history": messageHistory,
        "citation_format": citationFormat,
        "websearch": websearch,
    })

    try {
        const response = await axios.post(serverIP + '/multidoc/chat_with_multidoc', {
            "user_id": user_id.toString(),
            "multidoc_session_token": generation_session_token.toString(),
            "prompt": prompt.toString(),
            // "word_count": word_count,
            // "should_reference_sources": should_reference_sources,
            "socketio_sid": socketID,
            "message_history": messageHistory,
            "citation_format": citationFormat,
            "websearch": websearch,
        });
        console.log("response for /chat_with_multidoc", response)

        if (response.data.status === 429) {
            // this is actually rate limit exceeded
            toast({
                title: "Rate limit exceeded for chats. Please take a quick break and come back later!",
                status: "error",
                duration: 9000,
                isClosable: true,
                position: "top"
            })
            return null;
        }
        else if (response.data.message === "multidoc session token invalid or expired") {
            toast({
                title: "Session expired. Please RELOAD the page to continue chatting!",
                status: "error",
                duration: 5500,
                isClosable: true,
                position: "top"
            })
            return null;
        }
        else if (response.data.status === 402 && response.data.message === "free tier exceeded. Please subscribe to continue using the service") {
            toast({
                title: "(Free Plan) Chat Limit Exceeded!",
                status: "info",
                duration: 9000,
                isClosable: true,
                position: "top",
            });
            return {
                "status" : 402,
                "multidocSessionToken": "",
                "response": "",
            }
        }
        else if (response.data.status === 400 && response.data.message.includes("The input token count exceeds the maximum number of tokens allowed")) {
            // toast({
            //     title: "Too many input tokens. Please try removing 1 or more sources and try again.",
            //     status: "error",
            //     duration: 9000,
            //     isClosable: true,
            //     position: "top"
            // })
            return {
                "status" : 400,
            };
        }
        else if (response.data.status === 400 && response.data.message.includes("Other request error with LLM call")) {
            // toast({
            //     title: "Intermittent error, try again. Or try removing 1 or more sources & try again.",
            //     status: "error",
            //     duration: 10000,
            //     isClosable: true,
            //     position: "top"
            // })
            return {
                "status" : 400,
            };
        }
        else if (response.data.status === 200) {
            return {
                "status" : 200,
                "multidocSessionToken": response.data.message.multidoc_session_token,
                "response": response.data.message.response,
                "sourcesList": response.data.message.sources_list || [],
                "supportsList": response.data.message.supports_list || [],
            }
        } else {
            toast({
                title: "We’re experiencing exceptionally high demand. Please hang tight as we work on scaling our systems.",
                status: "error",
                duration: 5500,
                isClosable: true,
                position: "top"
            })
            return null;
        }
    } catch (error) {
        console.log("/chat_with_multidoc error", error);
        toast({
            title: "We’re experiencing exceptionally high demand. Please hang tight as we work on scaling our systems.",
            status: "error",
            duration: 5500,
            isClosable: true,
            position: "top"
        })
        return null;
    }
}

export const multidocChatNative = async (user_id, generation_session_token, prompt,
                                         socketID, toast, messageHistory, serverIP, citationFormat = "default", websearch = false) => {
    console.log("multidoc chat native request body", {
        // "user_id": user_id.toString(),
        "multidoc_session_token": generation_session_token.toString(),
        "prompt": prompt.toString(),
        // "word_count": word_count,
        // "should_reference_sources": should_reference_sources,
        "socketio_sid": socketID,
        "message_history": messageHistory,
        "citation_format": citationFormat,
        "websearch": websearch,
    })

    try {
        const response = await axios.post(serverIP + '/multidoc/chat_with_multifile_native', {
            // "user_id": user_id.toString(),
            "multidoc_session_token": generation_session_token.toString(),
            "prompt": prompt.toString(),
            // "word_count": word_count,
            // "should_reference_sources": should_reference_sources,
            "socketio_sid": socketID,
            "message_history": messageHistory,
            "citation_format": citationFormat,
            "websearch": websearch,
        });
        console.log("response for /chat_with_multifile_native", response)

        if (response.data.status === 429) {
            // this is actually rate limit exceeded
            toast({
                title: "Rate limit exceeded for chats. Please take a quick break and come back later!",
                status: "error",
                duration: 9000,
                isClosable: true,
                position: "top"
            })
            return null;
        }
        else if (response.data.message === "multidoc session token invalid or expired") {
            toast({
                title: "Session expired. Please RELOAD the page to continue chatting!",
                status: "error",
                duration: 5500,
                isClosable: true,
                position: "top"
            })
            return null;
        }
        else if (response.data.status === 402 && response.data.message === "free tier exceeded. Please subscribe to continue using the service") {
            toast({
                title: "(Free Plan) Chat Limit Exceeded!",
                status: "info",
                duration: 9000,
                isClosable: true,
                position: "top",
            });
            return {
                "status" : 402,
                "multidocSessionToken": "",
                "response": "",
            }
        }
        else if (response.data.status === 400 && response.data.message.includes("The input token count exceeds the maximum number of tokens allowed")) {
            toast({
                title: "Too many input tokens. Please try removing 1 or more sources and try again.",
                status: "error",
                duration: 9000,
                isClosable: true,
                position: "top"
            })
            return {
                "status" : 400,
            };
        }
        else if (response.data.status === 400 && response.data.message.includes("Other request error with LLM call")) {
            toast({
                title: "Intermittent error, try again. Or try removing 1 or more sources & try again.",
                status: "error",
                duration: 10000,
                isClosable: true,
                position: "top"
            })
            return {
                "status" : 400,
            };
        }
        else if (response.data.status === 200) {
            return {
                "status" : 200,
                "multidocSessionToken": response.data.message.multidoc_session_token,
                "response": response.data.message.response,
                "sourcesConsidered": response.data.message.sources_considered,
                "timeTaken": response.data.message.time_taken,
                "sourcesList": response.data.message.sources_list || [],
                "supportsList": response.data.message.supports_list || [],
            }
        } else {
            toast({
                title: "We’re experiencing exceptionally high demand. Please hang tight as we work on scaling our systems.",
                status: "error",
                duration: 5500,
                isClosable: true,
                position: "top"
            })
            return null;
        }
    } catch (error) {
        console.log("/chat_with_multifile_native error", error);
        toast({
            title: "We’re experiencing exceptionally high demand. Please hang tight as we work on scaling our systems.",
            status: "error",
            duration: 5500,
            isClosable: true,
            position: "top"
        })
        return null;
    }
}

export const addActiveSourcesMultidoc = async (multidoc_id, user_id, source_ids, serverIP) => {
    console.log("/add_source_to_active_session REQUEST BODY", {
        "multidoc_session_token": multidoc_id.toString(),
        "user_id": user_id.toString(),
        "source_ids": source_ids,
    });
    // response.data.session_token or response.data.url
    try {
        const response = await axios.post(serverIP + '/multidoc/add_source_to_active_session', {
            "multidoc_session_token": multidoc_id.toString(),
            "user_id": user_id.toString(),
            "source_ids": source_ids,
        });
        console.log("response for add_source_to_active_session", response)

        if (response.data.status === 429) {
            alert("We're experiencing unusually high traffic right now. Please try again in a few minutes!")
        }
        else if (response.data.status === 200) {
            return {
                "status" : 200,
                "sources_added": response.data.message.sources_added,
                "all_active_sources": response.data.message.all_active_sources,
                "sources_unable_to_add": response.data.message.sources_unable_to_add,
                "num_tokens_used": response.data.message.num_tokens_used,
                "num_tokens_left": response.data.message.num_tokens_left,
            }
        } else if (response.data.status === 402) {
            return {
                "status" : 402,
            }
        }
    } catch (error) {
        console.log("/add_source_to_active_session error", error);
        return null;
    }
}

export const removeActiveSourcesMultidoc = async (multidoc_id, user_id, source_id, serverIP) => {
    console.log("/remove_source_from_active_session REQUEST BODY", {
        "multidoc_session_token": multidoc_id.toString(),
        "user_id": user_id.toString(),
        "source_id": source_id,
    });
    // response.data.session_token or response.data.url
    try {
        const response = await axios.post(serverIP + '/multidoc/remove_source_from_active_session', {
            "multidoc_session_token": multidoc_id.toString(),
            "user_id": user_id.toString(),
            "source_id": source_id,
        });
        console.log("response for remove_source_from_active_session", response)

        if (response.data.status === 429) {
            alert("We're experiencing unusually high traffic right now. Please try again in a few minutes!")
        }
        else if (response.data.status === 200) {
            return {
                "status" : 200,
                "active_sources": response.data.message.active_sources,
                "num_tokens_used": response.data.message.num_tokens_used,
                "num_tokens_left": response.data.message.num_tokens_left,
            }
        } else if (response.data.status === 402) {
            return {
                "status" : 402,
            }
        }
    } catch (error) {
        console.log("/remove_source_from_active_session error", error);
        return null;
    }
}

export const renameMultidoc = async (newName, userID, generationID, serverIP) => {
    console.log("RENAME MULTIDOC payload", {
        "new_multidoc_title": newName.toString(),
        "user_id": userID.toString(),
        "multidoc_id": generationID.toString
    });

    try {
        const response = await axios.post(serverIP + '/multidoc/rename_multidoc', {
            "new_multidoc_title" : newName.toString(),
            "user_id" : userID.toString(),
            "multidoc_id" : generationID.toString(),
        });
        console.log("response from /multidoc/rename_multidoc", response)
        if (response.data.status === 200) {
            return {
                "status" : 200,
            }
        } else if (response.data.status === 401) {
            return {
                "status" : 401,
            }
        }
    } catch (error) {
        console.log("/multidoc/rename_multidoc", error);
        return null;
    }
}

export const deleteMultidoc = async (userID, generationID, serverIP) => {
    console.log("DELETE MULTIDOC payload", {
        "user_id": userID,
        "multidoc_id": generationID,
    });

    try {
        const response = await axios.post(serverIP + '/multidoc/delete_multidoc', {
            "user_id" : userID,
            "multidoc_id" : generationID,
        });
        console.log("response from /multidoc/delete_multidoc", response)
        if (response.data.status === 200) {
            return {
                "status" : 200,
            }
        } else if (response.data.status === 401) {
            return {
                "status" : 401,
            }
        }
    } catch (error) {
        console.log("/multidoc/delete_multidoc error", error);
        return null;
    }
}

export const removeSourceMultidoc = async (userID, fileID, multidocID, multidocSessionID, serverIP) => {
    console.log("REMOVE SOURCE MULTIDOC payload", {
        "user_id": userID,
        "file_id": fileID,
        "multidoc_id": multidocID,
        "multidoc_session_id": multidocSessionID,
    });

    try {
        const response = await axios.post(serverIP + '/multidoc/remove_source_multidoc', {
            "user_id" : userID,
            "file_id" : fileID,
            "multidoc_id" : multidocID,
            "multidoc_session_id" : multidocSessionID,
        });
        console.log("response from /multidoc/remove_source_multidoc", response)
        if (response.data.status === 200) {
            return {
                "status" : 200,
            }
        } else if (response.data.status === 401) {
            return {
                "status" : 401,
            }
        }
    } catch (error) {
        console.log("/multidoc/remove_source_multidoc error", error);
        return null;
    }
}

export const postChatPairMultidoc = async (listOfMessages, userID, multidocID, isLoggedIn, serverIP) => {
    const requestBody = {
        "chat": listOfMessages,
        "user_id": isLoggedIn ? userID : "11111111-1111-1111-1111-111111111111",
        "multidoc_id": multidocID
    }
    console.log("postChatPairMultidoc request body", requestBody)
    try {
        const response = await axios.post(serverIP + '/multidoc/save_chat', requestBody);
        console.log("response from multidoc post chat", response)

        // if (response.status === 200) {
        //     return response.data.text;
        // } else {
        //     throw new Error('getClaudeResponse error');
        // }
    } catch (error) {
        console.log("post chat multidoc error", error);
    }
}

// Large context synthesis for documents exceeding 1M tokens
// This agent processes documents in multiple steps (scratchpad, etc.) before outputting an answer
export const largeContextSynthesis = async (user_id, multidoc_id, query, socketio_stream_room, serverIP, toast) => {
    console.log("large_context_synthesis", {
        "user_id": user_id,
        "multidoc_id": multidoc_id,
        "query": query,
        "socketio_stream_room": socketio_stream_room,
    });

    try {
        const response = await axios.post(serverIP + '/p36b/large_context_synthesis', {
            "user_id": user_id,
            "multidoc_id": multidoc_id,
            "query": query,
            "socketio_stream_room": socketio_stream_room,
        });
        console.log("response for /p36b/large_context_synthesis", response);

        if (response.data.status === 401) {
            toast({
                title: "Authentication failed. Please log in and try again.",
                status: "error",
                duration: 9000,
                isClosable: true,
                position: "top"
            });
            return { status: 401 };
        }
        else if (response.data.status === 429) {
            toast({
                title: "Rate limit exceeded. Please take a quick break for 1 minute and come back later!",
                status: "error",
                duration: 9000,
                isClosable: true,
                position: "top"
            });
            return null;
        }
        else if (response.data.status === 400 && response.data.message.includes("estimated tokens, max allowed is")) {
            toast({
                title: "Too many input tokens. Please try removing 1 or more sources and try again.",
                status: "error",
                duration: 9000,
                isClosable: true,
                position: "top"
            });
            generalAdminNotification(user_id, "LargeContext over 5 million tokens BY USER " + user_id.toString());
            return null;
        }
        else if (response.data.status === 503) {
            toast({
                title: "We’re experiencing exceptionally high demand. Please hang tight as we work on scaling our systems.",
                status: "error",
                duration: 6000,
                isClosable: true,
                position: "top"
            });
            return { status: 503 };
        }
        else if (response.data.status === 200) {
            return {
                status: 200,
                celeryTaskId: response.data.message.celery_task_id,
                multidocId: response.data.message.multidoc_id,
            };
        } else {
            toast({
                title: "We’re experiencing exceptionally high demand. Please hang tight as we work on scaling our systems.",
                status: "error",
                duration: 5500,
                isClosable: true,
                position: "top"
            });
            return null;
        }
    } catch (error) {
        console.log("/p36b/large_context_synthesis error", error);
        toast({
            title: "We’re experiencing exceptionally high demand. Please hang tight as we work on scaling our systems.",
            status: "error",
            duration: 5500,
            isClosable: true,
            position: "top"
        });
        return null;
    }
};

// Poll progress for large context synthesis task
export const pollLargeContextProgress = async (celeryTaskId, serverIP) => {
    try {
        const response = await axios.get(serverIP + '/progress/' + celeryTaskId);
        console.log("response for /progress/" + celeryTaskId, response);
        return response.data;
    } catch (error) {
        console.log("/progress error", error);
        return null;
    }
};

// this code is done
export const clearChatHistoryMultidoc = async (userID, multidocID, isLoggedIn, serverIP) => {
    const requestBody = {
        "user_id": isLoggedIn ? userID : "11111111-1111-1111-1111-111111111111",
        "multidoc_id": multidocID
    }
    console.log("/multidoc/clear_chat_history request body", requestBody)
    try {
        const response = await axios.post(serverIP + '/multidoc/clear_chat_history', requestBody);
        console.log("response from /multidoc/clear_chat_history", response)

        if (response.data.status === 200) {
            return "success";
        } else {
            return "failure";
        }
    } catch (error) {
        console.log("/multidoc/clear_chat_history error", error);
    }
}

